import { useState } from "react";
import { NotificationManager } from "react-notifications";

function useExcel(items) {
  const [value, setValue] = useState([{ ...items }]);

  const calculateQTYRem = (index, recived, remain) => {
    console.log(index, recived, remain)
    const arr = [...value];
    arr[index]["Qty. Remaining"] = parseInt(remain ?? "0") - parseInt(recived ?? "0");
    setValue(arr);

  }

  const calculatePrice = (index, order, price) => {
    console.log(index, order, price)
    if (order && price) {
      const arr = [...value];
      arr[index]["Total Price"] = parseInt(order ?? 0) * parseInt(price ?? 0);
      setValue(arr);
    }
  }

  const onChange = (e, index, i) => {
    const arr = [...value];

    switch (e.target.id) {
      case "Line No.":
        arr[index][e.target.id] = e.target.value;
        setValue(arr);
        break;

      case "Item No.":
        arr[index][e.target.id] = e.target.value;
        setValue(arr);
        break;

      case "Description":
        arr[index][e.target.id] = e.target.value;
        setValue(arr);
        break;

      case "Inner Packs":
        arr[index][e.target.id] = e.target.value;
        setValue(arr);
        break;

      case "Inner Package Type":
        arr[index][e.target.id] = e.target.value;
        setValue(arr);
        break;

      case "Outer pack":
        arr[index][e.target.id] = e.target.value;
        setValue(arr);
        break;

      case "Outer Package Type":
        arr[index][e.target.id] = e.target.value;
        setValue(arr);
        break;

      case "Qty. Ordered":
        arr[index][e.target.id] = e.target.value;
        setValue(arr);
        calculatePrice(index, e.target.value, arr[index]["Item Price"])
        break;

      case "Qty. Received":
        if (parseInt(arr[index]["Qty. Ordered"] ?? 0) < parseInt(e.target.value ?? "0")) {
          NotificationManager.error("Quantity Received is not more then Quantity Ordered", "", 3000);
        } else {
          arr[index][e.target.id] = e.target.value;
          setValue(arr);
          calculateQTYRem(index, e.target.value, arr[index]["Qty. Ordered"])
        }
        break;

      case "Qty. Remaining":
        arr[index][e.target.id] = e.target.value;
        setValue(arr);
        break;

      case "Unit of Qty.":
        arr[index][e.target.id] = e.target.value;
        setValue(arr);

        break;
      case "Item Price":
        arr[index][e.target.id] = e.target.value;
        setValue(arr);
        calculatePrice(index, arr[index]["Qty. Ordered"], e.target.value)
        break;

      case "Total Price":
        break;
      case "Req. in Store Date":
        console.log("store", e.target.value, e.target.id);
        arr[index][e.target.id] = e.target.value;
        setValue(arr);
        break;

      case "INCO term":
        arr[index][e.target.id] = e.target.value;
        setValue(arr);
        break;

      case "Additional Terms":
        arr[index][e.target.id] = e.target.value;
        setValue(arr);
        break;

      case "Confirm Number":
        arr[index][e.target.id] = e.target.value;
        setValue(arr);
        break;

      case "Confirm Date":
        arr[index][e.target.id] = e.target.value;
        setValue(arr);
        break;

      default:
        console.log("no input matched", e.target.id, e.target.value);
    }
  };

  return {
    value,
    setValue,
    onChange,
  };
}

export default useExcel;
